import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "도구",
  "description": "monorepo에서 선호하는 도구를 사용하는 방법을 알아보세요."
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "Turborepo는 모든 선호 도구와 함께 작동합니다. 아래에서 Turborepo와 함께 사용되는 가장 일반적인 도구에 대한 가이드를 찾을 수 있습니다."
  }],
  "headings": []
};
import {Cards, Card} from '#components/card';
export const toc = [];
function _createMdxContent(props) {
  const _components = {
    p: "p",
    strong: "strong",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsxs(_components.p, {
      children: ["Turborepo는 ", _jsx(_components.strong, {
        children: "모든 선호 도구"
      }), "와 함께 작동합니다. 아래에서 Turborepo와 함께 사용되는 가장 일반적인 도구에 대한 가이드를 찾을 수 있습니다."]
    }), "\n", _jsxs(Cards, {
      children: [_jsx(Card, {
        title: "Biome",
        href: "/docs/guides/tools/biome"
      }), _jsx(Card, {
        title: "Docker",
        href: "/docs/guides/tools/docker"
      }), _jsx(Card, {
        title: "ESLint",
        href: "/docs/guides/tools/eslint"
      }), _jsx(Card, {
        title: "Jest",
        href: "/docs/guides/tools/jest"
      }), _jsx(Card, {
        title: "Prisma",
        href: "/docs/guides/tools/prisma"
      }), _jsx(Card, {
        title: "shadcn/ui",
        href: "/docs/guides/tools/shadcn-ui"
      }), _jsx(Card, {
        title: "Storybook",
        href: "/docs/guides/tools/storybook"
      }), _jsx(Card, {
        title: "TypeScript",
        href: "/docs/guides/tools/typescript"
      }), _jsx(Card, {
        title: "Vitest",
        href: "/docs/guides/tools/vitest"
      })]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
